function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7f8de1",
  d: "M107.3,110.6H17.7c-5.2,0-9.5-4.2-9.5-9.5V23.9c0-5.2,4.2-9.5,9.5-9.5h89.6c5.2,0,9.5,4.2,9.5,9.5v77.2 C116.8,106.3,112.5,110.6,107.3,110.6z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  fill: "#ffffff",
  cx: 76.9,
  cy: 54.5,
  rx: 14,
  ry: 14.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M76.9,98.3c-7,0-14.5,0.2-19.5-0.1c-2.3-0.1-3.6-0.4-5-1.7c-1.9-1.9-1.8-4.7-1.8-7c0-7.4,11.8-13.5,26.3-13.5 L76.9,98.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M76.9,98.3c7,0,14.5,0.2,19.5-0.1c2.3-0.1,3.6-0.4,5-1.7c1.9-1.9,1.8-4.7,1.8-7c0-7.4-11.8-13.5-26.3-13.5 L76.9,98.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M59.2,31.1H21.8v62.7h21.9c-0.3-1.7-0.3-3.4-0.3-5c0-6.4,6.3-12,15.8-15.5v-5.2c-2.8-3.3-4.6-7.6-4.6-12.3 s1.7-9.1,4.6-12.3V31.1z M28.7,40h6.7v6.7h-6.7V40z M28.7,53.5h6.7v6.7h-6.7V53.5z M28.7,66.9h6.7v6.7h-6.7V66.9z M35.4,87.1h-6.7 v-6.7h6.7V87.1z M51.1,73.6h-6.7v-6.7h6.7V73.6z M51.1,60.1h-6.7v-6.7h6.7V60.1z M51.1,46.7h-6.7V40h6.7V46.7z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125 125"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/user-profile-icon.347c2e8d.svg";
export { SvgComponent as ReactComponent };